import { Box, Button, Card, CardContent, FormControl, Unstable_Grid2 as Grid, InputLabel, List, ListItem, MenuItem, Paper, Select, TextField, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { DropdownModel, NLCInfo, StationUpdate, TableVersionItem } from "../../../data/interfaces/sharedmodels";
import masterlistService from "../../../data/api/masterlist.service";
import commonService from "../../../data/api/common.service";
import ConfirmDialog from "../../../shared/confirmdialog";
import { useAppDispatch } from "../../../stores/hooks";
import { showerrormessage, showsuccessmessage,showwarningmessage } from "../../../stores/notificationslice";


export default function CreateStationForm({id,cancel,callbackupdatelisttype}:{id:string,cancel:any,callbackupdatelisttype:any}) {
    const dispatch=useAppDispatch();
    const [stations, setStations] = useState<NLCInfo[]>([]);
    const [magStation, setMagStation] = useState<string>();
    const [itsotation, setItsoStation] = useState<string>();
    const[stationName,setStationName]=useState<string>();
    const[nlc,setNlc]=useState<string>();
    const[ipAddress,setIpAddress]=useState<string>();
    const [versions, setVersions] = useState<TableVersionItem[]>([]);
    const [dialogOpen, setDialogOpen] = useState<boolean>(false);
    const [dialogTitle, setDialogTitle] = useState<string>('');
    const [dialogMessage, setDialogMessage] = useState<string>('');
    const[currentStation,setCurrentStation]=useState<NLCInfo|undefined>();
    useEffect(() => {
        commonService.getnlcs().then((response) => {
            setStations(response.data);
        })
    }, []);

    useEffect(() => {
        if (stations && stations.length) {
            setMagStation(stations[0].Id.toString());
            setItsoStation(stations[0].Id.toString());
        }
        if(id){
            let station=stations.filter(a=>a.Id.toString()==id)[0];
            setCurrentStation(station);
            setNlc(station?.NLC??"");
            setStationName(station?.StationName??"");
            setIpAddress(station?.SCUIpAddress??"");
        }
    }, [stations]);
    

    useEffect(() => {
        if (magStation && itsotation&& !currentStation) {
            masterlistService.getTableVersions(magStation, itsotation).then((response) => {
                setVersions(response.data);
            })
        }
    }, [magStation, itsotation]);

    const handleCreateStation=()=>{
        if(currentStation&&currentStation.StationName==stationName&&currentStation.SCUIpAddress==ipAddress){
            dispatch(showwarningmessage("No data has changed."));
            return;
        }
        setDialogTitle('Create Station');
        let dataMisMessage="There is no data present in '"+versions.filter(a=>a.Version==null).length+"' tables."
        setDialogMessage((versions.filter(a=>a.Version==null).length>0?dataMisMessage:'')+
        'Confirm '+(currentStation?"update":"create")+ ' of station \'' + nlc+' - '+ stationName + '\'?');

        setDialogOpen(true);
    }

    const createStation = useCallback((confirmed: boolean, remarks: string, type: string) => {
        setDialogOpen(false);
        if(confirmed){
            let inputData:StationUpdate;
            if(currentStation){
                inputData={MagneticStationId:undefined,ItsoStationId:undefined,TocId:undefined,
                    Station:{Id:currentStation.Id,StationName:stationName??"",NLC:currentStation.NLC,SCUIpAddress:ipAddress??null}
               }
            }
            else{
                inputData={MagneticStationId:magStation,ItsoStationId:itsotation,TocId:undefined,
                    Station:{Id:0,StationName:stationName??"",NLC:nlc??"",SCUIpAddress:ipAddress??null}
               }
            }

            masterlistService.updateStation(inputData).then((response)=>{
                if(response.data){
                    cancel(null);
                    callbackupdatelisttype(7);
                    dispatch(showsuccessmessage("The station '"+nlc+" - "+stationName+"' updated successfully."))
                }
                else{
                    dispatch(showerrormessage("Unexpected error occured during creating the station, Please try again"));
                }
            })
             
        }
    },[currentStation,stationName,nlc,ipAddress,magStation,itsotation]);




    return (

        <Grid container spacing={2} sx={{p:1}}>
            <Grid xs={12}>
                <Typography variant="h5">Create New Station</Typography>
            </Grid>
            <Grid xsOffset={currentStation?3:0}  xs={6} spacing={1}>
                <Box component='form' sx={{display:'flex',justifyContent:'space-between'}}>
                <TextField  required sx={{ width: '100%',m:1}} label="Station Name" value={stationName??""} onChange={(event)=>setStationName(event.target.value)}/>

                <TextField disabled={currentStation!=undefined} type="number" helperText="Please enter value between 1-9999" required sx={{ width: '100%',m:1 }} label="NLC" value={nlc??0} 
                onChange={(event)=>setNlc(event.target.value)} InputProps={{
                    inputProps: {
                        min: 1,
                        max: 9999,
                        step: 1
                    },
                }}/>
                <TextField  required sx={{ width: '100%',m:1}} label="SCU Ip Address" value={ipAddress??""} onChange={(event)=>setIpAddress(event.target.value)}/>
                </Box>
                {currentStation?null:
                <Box sx={{display:'flex',justifyContent:'space-between'}}>
                <FormControl sx={{ width: '100%',m:1}} >
                    <InputLabel>Magnetic Station</InputLabel>
                    <Select
                        size="small"
                        label="Magnetic Station"
                        sx={{ width: '100%',p:1 }}
                        value={magStation??""}
                        onChange={(event) => setMagStation(event.target.value)}>

                        {
                            stations.map((item) => {
                                return (
                                    <MenuItem key={item.Id} value={item.Id}>{item.NLC + " - " + item.StationName}</MenuItem>
                                )
                            })}

                    </Select>
                    
                </FormControl>
                <FormControl sx={{ width: '100%',m:1}} >
                    <InputLabel>ITSO Station</InputLabel>
                    <Select
                        size="small"
                        label="ITSO Station"
                        sx={{ width: '100%',p:1 }}
                        value={itsotation??""}
                        onChange={(event) => setItsoStation(event.target.value)}>

                        {
                            stations.map((item) => {
                                return (
                                    <MenuItem key={item.Id} value={item.Id}>{item.NLC + " - " + item.StationName}</MenuItem>
                                )
                            })}


                    </Select>
                </FormControl>
                
                </Box>}
                <Box sx={{width:'100%', display:'flex', justifyContent:'end'}}>
                <Button variant="outlined" sx={{mr:1}} onClick={()=>cancel(null)}>Cancel</Button>
                <Button type="submit" variant="contained" sx={{mr:1}} disabled={!stationName||!nlc||Number.parseInt(nlc)<1||Number.parseInt(nlc)>9999||!magStation||!itsotation} onClick={handleCreateStation} >{currentStation?'Save':'Create'}</Button>
                </Box>
                
            </Grid>
            {currentStation?null:
            <Grid container xs={6}>
                <Grid xs={6}>
                    <Typography variant="h5" sx={{ml:2}}>Magnetic Tables</Typography>
                    <List>
                        {versions.filter(a => a.Type == "Magnetic").map((version) => {
                            return (
                                <ListItem key={version.Id} dense component={Paper} sx={{p:1,m:1}}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between',width:'100%'  }}>
                                                <Typography variant="body1">{version.Description}</Typography>
                                                <Typography variant="body1">{version.Version}</Typography>
                                            </Box>
                                </ListItem>
                            )
                        })}
                    </List>
                </Grid>
                <Grid xs={6}>
                <Typography variant="h5" sx={{ml:2}}>ITSO Tables</Typography>
                    <List>
                        {versions.filter(a => a.Type == "ITSO").map((version) => {
                            return (
                                <ListItem key={version.Id} dense component={Paper} sx={{p:1,m:1}}>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between',width:'100%' }} color={!version.Version?"red":"inherit"}>
                                                <Typography  variant="body1">{version.Description}</Typography>
                                                <Typography  variant="body1">{version.Version??"No Data"}</Typography>
                                            </Box>
                                    

                                </ListItem>
                            )
                        })}
                    </List>
                </Grid>
            </Grid>}
            <ConfirmDialog needComments={false} isopen={dialogOpen} title={dialogTitle} message={dialogMessage} callback={createStation} />
        </Grid>

    )
}